import { render, staticRenderFns } from "./DepositDialog.vue?vue&type=template&id=147b4036&scoped=true&"
import script from "./DepositDialog.vue?vue&type=script&lang=js&"
export * from "./DepositDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b4036",
  null
  
)

export default component.exports